/**
 * Force a UI event to fire
 * @param element Target element
 * @param event Target event
 */
export function trigger(element, event) {
  if (document.createEvent) {
    // Other IE
    const evt = document.createEvent('HTMLEvents');

    evt.initEvent(event, true, true); // event type, bubbling, cancelable

    return element.dispatchEvent(evt);
  } else {
    // IE
    const evt = (document as any).createEventObject();

    return element.fireEvent('on' + event, evt);
  }
}
